/* eslint-disable @typescript-eslint/no-explicit-any */
import { expectContent } from "@/content/utils/expectContent";

import {
    collectionFragment,
    assetFragment,
    relatedTemplateFragment
} from "../fragments";
import {
    ITemplatePageLoader,
    parseCategories,
    parseCollection
} from "../get-content-data";

export const ConfluenceTemplateCollectionDetailsPageLoader: ITemplatePageLoader =
    {
        getQueryData: (urlSlug: string, locale: string) => {
            const staticCollectionFirstSlug =
                urlSlug === "project-management"
                    ? "product-managers"
                    : "project-management";
            const staticCollectionSecondSlug =
                urlSlug === "strategic-planning"
                    ? "product-managers"
                    : "strategic-planning";
            return {
                query: `#graphql
            query getCollections {
                templateCollections(search: {queries: {first: 1, withLocales: ["${locale}"], where: { searchText: {
                    exactlyMatching: {fieldNamed: "urlSlug", havingValues: ["${urlSlug}"] }}}}}) {
                    edges {
                        node {
                            ...collectionFragment
                        }
                    }
                }
                staticCollections: templateCollections(
                    search: {queries: {first: 2, withLocales: ["${locale}"], where: {searchText: {
                        exactlyMatching: {fieldNamed: "urlSlug", havingValues: ["${staticCollectionFirstSlug}", "${staticCollectionSecondSlug}"]}}}}}
                ) {
                    edges {
                        node {
                            name
                            urlSlug
                            collectionIcon {
                                ...contentPlatformImageAsset
                            }
                            howToUseThisCollection {
                                collectionSteps {
                                    relatedTemplate {
                                        templateId
                                    }
                                }
                            }
                        }
                    }
                }
                contentFacet(first: 25, forFields: ["category"], forContentType: "Template", withLocales: ["${locale}"]) {
                    edges {
                      node {
                        context
                      }
                    }
                  }
            }
            ${collectionFragment}
            ${assetFragment}
            ${relatedTemplateFragment}
            `,
                variables: {}
            };
        },
        parseData: (data: any, locale?: string) => {
            const collections = [];
            const categories = parseCategories(data.contentFacet.edges, locale);
            for (const { node } of data.templateCollections.edges) {
                collections.push(parseCollection(node));
            }

            for (const { node } of data.staticCollections.edges) {
                collections.push(node);
            }

            // Throw an error if we don't find any collections. Check based on related templates
            if (
                collections[0].howToUseThisCollection.collectionSteps.length !=
                0
            ) {
                expectContent(
                    collections[0].howToUseThisCollection.collectionSteps[0]
                        .relatedTemplate.urlSlug,
                    "No collections found"
                );
            }

            return {
                collections,
                categories
            };
        }
    };
